import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { DatePipe, CommonModule } from '@angular/common';
import { NgxPrintModule } from 'ngx-print'; // <-- Import this
import * as XLSX from 'xlsx';
import { BookSellerRegistrationComponent } from '../pages/book-seller-registration/book-seller-registration.component';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-issue-seller-address-list-component',
  standalone: true,
  imports: [CommonModule, NgxPrintModule], // <-- Add both modules here
  templateUrl: './issue-seller-address-list-component.component.html',
  styleUrl: './issue-seller-address-list-component.component.scss'
})
export class IssueSellerAddressListComponentComponent implements OnInit {

  Address: any[] = [];
  contractDetailsForm: FormGroup;
   currentDate= new Date();
   reportType: string = 'AdvertisementAddressList';
  show: boolean;

  constructor(
    private dialogRef: MatDialogRef<BookSellerRegistrationComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.contractDetailsForm = this.fb.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    const repname = this.data['repName'] || '';  // Make sure repname is correctly defined

   const req: any = {
      "rep_name": repname,
      "startDate": this.data['startDate'],
      "endDate": this.data['endDate'],
      "off_rep_name": this.data['offRepName'],
      "issue_seller_name": this.data['name'],
      "issue_date": "",
      "issue_name": "",
    
    };

    this.service.getAllissuesellerAdd(req).subscribe(
      (data1: any) => {
        this.Address = data1;
        console.log("Final Address array:", this.Address);
      },
      (error) => {
        console.error("Error fetching addresses:", error);
      }
    );
  }

  print() {
    const originalTitle = document.title; // Store original title
    document.title = '';     // Set custom print title
  
    // Create a style tag for print-specific styles
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 10mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;
  
    document.head.appendChild(style); // Add style to the document
  
    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();
      
      document.title = ''; // Restore original title after printing
      
      // document.head.removeChild(style); // Remove the style after printing
    }, 500); // Delay ensures styles apply before printing
  }

  exportExcel(fileName: string): void {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.Address); // your data array
  const workbook: XLSX.WorkBook = {
    Sheets: { 'data': worksheet },
    SheetNames: ['data']
  };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + '.xlsx');
}
closeDialog(): void {
  this.dialogRef.close();
}

}
